import React from 'react';
/**
 * Advanced markers require a vector mapId. When no mapId is configured at build time,
 * Marker falls back to classic {@link google.maps.Marker} so the map still loads.
 */
const AdvancedMarkerSupportContext = React.createContext(false);
function AdvancedMarkerSupportProvider({ value, children }) {
    return React.createElement(AdvancedMarkerSupportContext.Provider, { value: value }, children);
}
function useAdvancedMarkerSupported() {
    return React.useContext(AdvancedMarkerSupportContext);
}
export { AdvancedMarkerSupportProvider, useAdvancedMarkerSupported };
